import React from "react";

type LegendPayloadItem = {
  color: string;
  value: string;
};

interface CustomLegendProps {
  payload?: LegendPayloadItem[];
}

const CustomLegend: React.FC<CustomLegendProps> = ({ payload }) => {
  return (
    <div
      style={{
        display: "flex",
        gap: 20,
        flexWrap: "wrap",
        marginTop: 16,
        marginBottom: 25,
        justifyContent: "center",
      }}
    >
      {payload?.map(entry => (
        <div
          key={entry.value}
          style={{ display: "flex", alignItems: "center", gap: 6 }}
        >
          <div
            style={{
              width: 12,
              height: 12,
              backgroundColor: entry.color,
              borderRadius: 2,
              flexShrink: 0,
            }}
          />
          <span style={{ fontSize: 12 }}>{entry.value}</span>
        </div>
      ))}
    </div>
  );
};

export default CustomLegend;
